module.exports = __webpack_public_path__ + "images/saaremaa/ms-icon-310x310.png";